import { render, staticRenderFns } from "./ExamItem.vue?vue&type=template&id=773926f2&scoped=true"
import script from "./ExamItem.vue?vue&type=script&lang=js"
export * from "./ExamItem.vue?vue&type=script&lang=js"
import style0 from "./ExamItem.vue?vue&type=style&index=0&id=773926f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773926f2",
  null
  
)

export default component.exports